import { toast } from "react-toastify";
import { deleteItems, updateStateData } from "../Store/actions";
import store from "../Store/store";
import { fetch_adlevel_names, resetCampaignSheetData, restructure_product_information } from "./campaignSheet";
import { updateCampaignStatus } from "./campaigns";
import { createCookie, deleteCookie, sendApiRequest, setBatchLoadingStatus } from "./requestConfig";
import { LISTING_RELOAD, withListingReload } from "./listingReload";
import { fetchMarketingActivities, loadMarketingActivityStores } from "./marketingActivities";
import { fetchBrandFilters } from "./brandReport";
import {
  checkStatus,
  dbFormatDate,
  formatToStandardDate,
  standardFormatToday,
  fetchWeekNumbers,
  dateObjForToday,
  getFirstDayTwoMonthsAgo,
  erase_duplicates,
} from "./utils";
import platformConfig from "../platformConfig";
import moment from "moment-timezone";
import { checkUserDetailsFromCookie } from "./userManagement";
import { canEditAcrossCompanies, ownerCompanyIdForSave, ownerRequiredOnCreate, shouldSendSelectedOwner } from "./crossCompanyAccess";
import {
  clearStagedOwnerOutsideRetailerNotice,
  showStagedOwnerOutsideRetailerNotice,
  stageOwnerOutsideRetailerNotice,
} from "../components/commonComponents/Hoc/accessControlToasts";
import { fetchReportSettings } from "./ReportSettings";
import { fetchClipNames, loadAnalyticsCampaignStores } from "./clipRequests";
import { fetchVisualNames } from "./loopCampaign";
import { checkSectionAvailability } from "./WorkspaceSections";

const validateCampaignsInfo = (validateFor) => {
  const currentStateData = store.getState().userSelections;
  let error = false;
  let errorMessages = {};

  // campaign name
  const campaignName =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.campaign_name !== "undefined"
      ? currentStateData.new_campaign_data.campaign_name
      : "";
  // brand name
  const brandName =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.brand_name !== "undefined"
      ? currentStateData.new_campaign_data.brand_name
      : "";
  // start date
  const startDate =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.campaign_start_date !== "undefined"
      ? currentStateData.new_campaign_data.campaign_start_date
      : "";
  // end date
  const endDate =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.campaign_end_date !== "undefined"
      ? currentStateData.new_campaign_data.campaign_end_date
      : "";
  // campaign owner id
  const campaignOwnerId =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.campaign_owner_id !== "undefined"
      ? currentStateData.new_campaign_data.campaign_owner_id
      : "";
  const checkUserDetails = checkUserDetailsFromCookie();
  // brand company id
  const brandCompanyId =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.campaign_brand_company_id !== "undefined"
      ? currentStateData.new_campaign_data.campaign_brand_company_id
      : "";

  const manualBrandCompany =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.manual_brand_company !== "undefined"
      ? currentStateData.new_campaign_data.manual_brand_company
      : false;

  const manualBrandCompanyName =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.campaign_brand_company_name !== "undefined"
      ? currentStateData.new_campaign_data.campaign_brand_company_name
      : "";

  const reportStatus =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.report_status !== "undefined"
      ? currentStateData.new_campaign_data.report_status
      : "";

  const impressionStatus =
    typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.impression_status !== "undefined"
      ? currentStateData.new_campaign_data.impression_status
      : "";

  // check campaign
  if (campaignName === "") {
    error = true;
    errorMessages = {
      ...errorMessages,
      campaign_name: "Please enter the campaign name",
    };
  }
  // check brandName
  if (brandName === "") {
    error = true;
    errorMessages = {
      ...errorMessages,
      brand_name: "Please enter the brand name",
    };
  }
  // check start date
  if (startDate === "") {
    error = true;
    errorMessages = {
      ...errorMessages,
      start_date: "Please select the start date for the campaign",
    };
  }
  // check end date
  if (endDate === "") {
    error = true;
    errorMessages = {
      ...errorMessages,
      end_date: "Please select the end date for the campaign",
    };
  }

  // validate that start should not be after end date and vice versa
  if (startDate !== "" && endDate !== "") {
    const formattedStartDate = startDate; //dateInCorrectTimezone();
    const formattedEndDate = endDate; //dateInCorrectTimezone();
    //start/end should not be after end date
    if (formattedEndDate < formattedStartDate) {
      error = true;
      errorMessages = {
        ...errorMessages,
        end_date: "End date must be after the start date",
      };
    }
  }

  // retailer company
  if (ownerRequiredOnCreate(checkUserDetails.user_detail.user_type, validateFor, campaignOwnerId) === true) {
    error = true;
    errorMessages = {
      ...errorMessages,
      campaign_owner: "Please select the owner",
    };
  }
  // brand company
  if (brandCompanyId === "" && manualBrandCompany === false) {
    error = true;
    errorMessages = {
      ...errorMessages,
      brand_company: "Please select the brand company",
    };
  }

  if (manualBrandCompanyName === "" && manualBrandCompany === true) {
    error = true;
    errorMessages = {
      ...errorMessages,
      campaign_brand_company_name: "Please enter the brand company name",
    };
  }

  if (manualBrandCompanyName !== "" && manualBrandCompany === true) {
    // check if the name already exist
    if (
      typeof currentStateData.brand_names_arr !== "undefined" &&
      currentStateData.brand_names_arr.includes(manualBrandCompanyName)
    ) {
      error = true;
      errorMessages = {
        ...errorMessages,
        campaign_brand_company_name: "Brand company name already exists",
      };
    }
  }


  // show error message (if error === true)
  if (error === true) {
    toast("Please fill in valid information", { type: "error" });
    return {
      error: true,
      errorMessages,
    };
  } else {
    let campaignRequestObj = {
      brand: brandName,
      add_new_brand: manualBrandCompany,
      // retailer: parseInt(retailerCompanyId),
      date_end: dbFormatDate(new Date(endDate)),
      date_start: dbFormatDate(new Date(startDate)),
      name: campaignName,
      reporting: true,
      active: false,
      share_list:
        typeof currentStateData.new_campaign_data !== "undefined" &&
          typeof currentStateData.new_campaign_data.share_list !== "undefined"
          ? currentStateData.new_campaign_data.share_list
          : [],
    };

    if (manualBrandCompany === false) {
      campaignRequestObj = {
        ...campaignRequestObj,
        id_company_brand: parseInt(brandCompanyId),
      };
    } else {
      campaignRequestObj = {
        ...campaignRequestObj,
        new_brand_name: manualBrandCompanyName,
      };
    }

    // add campaign id (if found in redux)
    if (
      typeof currentStateData.new_campaign_data !== "undefined" &&
      typeof currentStateData.new_campaign_data.campaign_id !== "undefined" &&
      currentStateData.new_campaign_data.campaign_id !== ""
    ) {
      campaignRequestObj = {
        ...campaignRequestObj,
        id: currentStateData.new_campaign_data.campaign_id,
      };
      // add report status (if available)
      if (
        typeof currentStateData.new_campaign_data !== "undefined" &&
        typeof currentStateData.new_campaign_data.campaign_report_status_code !== "undefined" &&
        [2, 4].includes(currentStateData.new_campaign_data.campaign_report_status_code)
      ) {
        if (reportStatus === true) {
          campaignRequestObj = {
            ...campaignRequestObj,
            campaign_status: 4,
          };
        }
        if (reportStatus === false) {
          campaignRequestObj = {
            ...campaignRequestObj,
            campaign_status: 2,
          };
        }
      }

      if (impressionStatus === true) {
        campaignRequestObj = {
          ...campaignRequestObj,
          impression_status: 1,
        };
      }
    } else {
      campaignRequestObj = {
        ...campaignRequestObj,
        campaign_status: 0,
      };
    }

    // add owner info 
    if (shouldSendSelectedOwner(checkUserDetails.user_detail.user_type, validateFor, campaignOwnerId) === true) {
      campaignRequestObj = {
        ...campaignRequestObj,
        id_company_owner: campaignOwnerId,
      };

    }

    // return validated request body for the clips add/update operation
    return {
      error: false,
      campaign_request: campaignRequestObj,
    };
  }
};

// to save/update campaigns
export const saveCampaignsInformation = async (usedfor) => {
  const validateInfo = validateCampaignsInfo(usedfor);
  const currentStateData = store.getState().userSelections;
  let campaignResponse = {};
  if (validateInfo.error === true) {
    campaignResponse = {
      ...campaignResponse,
      success: false,
      errorMessages: validateInfo.errorMessages,
    };
  } else {
    try {
      setBatchLoadingStatus(true)

      let reqEndPoint =
        typeof validateInfo.campaign_request.id !== "undefined" && validateInfo.campaign_request.id !== ""
          ? "campaigns/update"
          : "campaigns/add";
      let reqMethod =
        typeof validateInfo.campaign_request.id !== "undefined" && validateInfo.campaign_request.id !== "" ? "PUT" : "POST";
      // Recorded before the request. The campaign form is cleared after a successful save.
      const requestOwnerId = validateInfo.campaign_request.id_company_owner;
      const ownerId =
        typeof requestOwnerId !== "undefined" && requestOwnerId !== ""
          ? requestOwnerId
          : ownerCompanyIdForSave(
              checkUserDetailsFromCookie().user_detail,
              currentStateData.new_campaign_data?.campaign_owner_id
            );
      stageOwnerOutsideRetailerNotice(ownerId, reqEndPoint === "campaigns/add");
      // send api request
      const saveCampaignInfo = await sendApiRequest(reqEndPoint, validateInfo.campaign_request, reqMethod);

      if (typeof saveCampaignInfo.success !== "undefined" && saveCampaignInfo.success === true) {
        // check if any error returned from the api
        if (
          typeof saveCampaignInfo.response !== "undefined" &&
          typeof saveCampaignInfo.response.success !== "undefined" &&
          saveCampaignInfo.response.success === false
        ) {
          if (
            typeof saveCampaignInfo.response.message !== "undefined" &&
            saveCampaignInfo.response.message === "DUPLICATE RESOURCES"
          ) {
            campaignResponse = {
              ...campaignResponse,
              success: false,
              errorMessages: {
                campaign_name: saveCampaignInfo?.response?.error_detail,
              },
            };
          } else {
            campaignResponse = {
              ...campaignResponse,
              success: false,
              errorMessages: {
                campaign_brand_company_name: saveCampaignInfo?.response?.error_detail,
              },
            };
          }

          toast("Please fill in valid information", { type: "error" });
        } else {
          const message = usedfor === "update" ? "Campaign updated successfully" : "Campaign added successfully";
          campaignResponse = {
            ...campaignResponse,
            success: true,
            message: message,
          };
          // store.dispatch(deleteItems(["campaign_list_filters", "filtered_campaign_list", "campaign_list_filter_applied"]));
          // deleteCookie("campaign_list_filters", true);
          // manageCampaignPaginationCookie({ scroll_pos: 0 });
          // loadCampaigns(0, currentStateData.campaign_pagination.pageSize);
          loadCampaigns(0, currentStateData.campaign_pagination.pageSize, { refreshOptions: true }).then(() =>
            setBatchLoadingStatus(false)
          );
          toast(message, { type: "success" });
          showStagedOwnerOutsideRetailerNotice();
        }
      } else {
        campaignResponse = {
          ...campaignResponse,
          success: false,
          errorMessages: "Sorry, Something went wrong",
        };
      }
    } finally {
      setBatchLoadingStatus(false);
      // A failed save never opened the box, so drop the value staged for this request.
      if (campaignResponse.success !== true) {
        clearStagedOwnerOutsideRetailerNotice();
      }
    }
  }
  return campaignResponse;
};

// manage pagination cookie infomation
export const manageCampaignPaginationCookie = (campaignPaginationObj) => {
  const currentStateData = store.getState().userSelections;
  //
  const paginationObj = typeof currentStateData.campaign_pagination !== "undefined" ? currentStateData.campaign_pagination : {};

  store.dispatch(updateStateData({ campaign_pagination: { ...paginationObj, ...campaignPaginationObj } }));
  deleteCookie("campaign_pagination");
  // set cookie for pagination
  createCookie("campaign_pagination", JSON.stringify({ ...paginationObj, ...campaignPaginationObj }));

}

// Load the campaign list. Table Loading… follows LISTING_RELOAD.campaigns.
// reloadOptions.refreshOptions is set after an add or update so filter dropdowns refetch.
export const loadCampaigns = async (pageNumber, pageSize, reloadOptions = {}) => {
  return withListingReload(
    LISTING_RELOAD.campaigns,
    () => loadCampaignsPage(pageNumber, pageSize),
    reloadOptions
  );
};

const loadCampaignsPage = async (pageNumber, pageSize) => {
  const currentStateData = store.getState().userSelections;
  // check if page number and page size are passed from the component, if not then set default values.
  if (typeof pageNumber === "undefined" && typeof pageSize === "undefined") {
    pageNumber = 0;
    pageSize = 10;
    // page number/size from the cookies if available
    if (typeof currentStateData.campaign_pagination !== "undefined") {
      pageNumber = currentStateData.campaign_pagination.pageNumber;
      pageSize = currentStateData.campaign_pagination.pageSize;
    }
  }
  let campaignListApiEndpoint = "campaigns?page=" + pageNumber + "&size=" + pageSize;
  // check if filters are applied, then we need to fetch the filtered list.
  if (
    typeof currentStateData.campaign_list_filter_applied !== "undefined" &&
    typeof currentStateData.campaign_list_filters !== "undefined" &&
    currentStateData.campaign_list_filter_applied === true
  ) {
    // campaign id/name filter
    if (
      typeof currentStateData.campaign_list_filters.campaign_name !== "undefined" &&
      currentStateData.campaign_list_filters.campaign_name.length !== 0
    ) {
      currentStateData.campaign_list_filters.campaign_name.forEach((item) => {
        campaignListApiEndpoint = campaignListApiEndpoint + "&campaign_id=" + item;
      });
    }
    // Owner filter (UI label stays "Owner"; Redux key is owner_filter)
    if (
      typeof currentStateData.campaign_list_filters.owner_filter !== "undefined" &&
      currentStateData.campaign_list_filters.owner_filter.length !== 0
    ) {
      currentStateData.campaign_list_filters.owner_filter.forEach((item) => {
        campaignListApiEndpoint = campaignListApiEndpoint + "&id_company=" + item;
      });
    }
    // Root retailer filter (UI label "Retailer"; Redux key root_retailer_filter)
    if (
      typeof currentStateData.campaign_list_filters.root_retailer_filter !== "undefined" &&
      currentStateData.campaign_list_filters.root_retailer_filter.length !== 0
    ) {
      currentStateData.campaign_list_filters.root_retailer_filter.forEach((item) => {
        campaignListApiEndpoint = campaignListApiEndpoint + "&retailer=" + item;
      });
    }
    // progress filter
    if (
      typeof currentStateData.campaign_list_filters.duration_filter !== "undefined" &&
      currentStateData.campaign_list_filters.duration_filter.length !== 0
    ) {
      currentStateData.campaign_list_filters.duration_filter.forEach((item) => {
        campaignListApiEndpoint = campaignListApiEndpoint + "&progress=" + item;
      });
    }

    // shared filter
    if (
      typeof currentStateData.campaign_list_filters.shared_filter !== "undefined" &&
      currentStateData.campaign_list_filters.shared_filter.length !== 0
    ) {
      currentStateData.campaign_list_filters.shared_filter.forEach((item) => {
        const sharedFilterVal = item === "Yes" ? true : false
        campaignListApiEndpoint = campaignListApiEndpoint + "&share=" + sharedFilterVal;
      });
    }
  }

  const campaignList = await sendApiRequest(campaignListApiEndpoint, {}, "GET");

  if (typeof campaignList.success !== "undefined" && campaignList.success === true) {
    //restructure the campaign list json to fetch only the required data from the response and then save it to redux state
    const getRestructuredData = restructureCampaignData(campaignList.response.content);

    store.dispatch(
      updateStateData({
        campaign_list: getRestructuredData,
      })
    );
    // save/update campaign pagination info
    manageCampaignPaginationCookie({
      totalPages: campaignList.response.totalPages,
      totalRecords: campaignList.response.totalElements,
      pageNumber: campaignList.response.number,
      pageSize: campaignList.response.size,
    });

    // scroll to the top of page
    window.scrollTo(0, 0);

    return {
      success: true,
    };
  } else {
    return {
      success: false,
    };
  }
};

export const loadCampaignsForUsers = async (ownerId) => {
  const currentStateData = store.getState().userSelections;
  //reset campaign list before loading the campaigns (if campaigns are already loaded.)
  resetCampaignSheetData();
  let endpoint = "campaigns/exclusive-list";
  if (typeof ownerId !== "undefined" && ownerId !== "") {
    endpoint = endpoint + "?owner_id=" + ownerId;
  }
  // Owner scopes this list. The bottom-nav retailer filter must not be added.
  const campaignList = await sendApiRequest(endpoint, {}, "GET", {
    skipRetailerViewFilter: true,
  });

  if (typeof campaignList.success !== "undefined" && campaignList.success === true) {
    //restructure the campaign list json to fetch only the required data from the response and then save it to redux state
    const getRestructuredData = restructureCampaignNameData(campaignList.response);

    store.dispatch(
      updateStateData({
        exclusive_campaign_list: getRestructuredData,
      })
    );

    // Same shape as fetchCampaignNames so Add Clip can read campaign dates
    // off the await result without a second campaigns/list call.
    return {
      success: true,
      data: getRestructuredData,
    };
  } else {
    return {
      success: false,
      data: null,
    };
  }
};

// -------- helpers for store availability APIs --------

// label ("Monday") or numeric index → 0-6
const weekdayLabelToIndex = { Sunday: 0, Monday: 1, Tuesday: 2, Wednesday: 3, Thursday: 4, Friday: 5, Saturday: 6 };
const normalizeWeekdaysParam = (weekdays) => {
  if (weekdays === null || typeof weekdays === "undefined") return null;
  if (!Array.isArray(weekdays)) return null;
  const normalized = weekdays
    .map((d) => (typeof d === "number" ? d : weekdayLabelToIndex[d]))
    .filter((d) => typeof d === "number" && d >= 0 && d <= 6);
  return normalized;
};

// shared body for both availability endpoints, null if required fields missing
const buildAvailabilityRequestBody = ({ storeIds, weekdays, startDate, endDate, calenderWeeks }) => {
  if (!Array.isArray(storeIds) || storeIds.length === 0) return null;

  const formattedStart = startDate && moment(startDate).isValid() ? dbFormatDate(startDate) : null;
  const formattedEnd = endDate && moment(endDate).isValid() ? dbFormatDate(endDate) : null;
  if (!formattedStart || !formattedEnd) return null;

  // Week selectors can provide either raw numbers or { value, label } options.
  const weeks = Array.isArray(calenderWeeks)
    ? calenderWeeks
      .map((week) => (typeof week === "object" && week !== null ? week.value : week))
      .filter((week) => typeof week === "number")
    : [];

  const normalizedWeekdays = normalizeWeekdaysParam(weekdays);

  const body = {
    storeIds,
    startDate: formattedStart,
    endDate: formattedEnd,
    calenderWeeks: weeks,
  };

  // Only attach `weekdays` in hour mode — backend switches response shape based on presence
  if (normalizedWeekdays !== null && normalizedWeekdays.length > 0) {
    body.weekdays = normalizedWeekdays;
  }

  return body;
};

// tries known field names for the hours array, returns [] on miss
const extractHoursArray = (responseBody) => {
  if (!responseBody || typeof responseBody !== "object") return [];
  const candidates = [responseBody.openedHours, responseBody.hours, responseBody.availableHours];
  for (const candidate of candidates) {
    if (Array.isArray(candidate)) {
      return candidate.filter((h) => typeof h === "number");
    }
  }
  return [];
};

// tries known field names for the weekdays array, returns [] on miss
const extractWeekdaysArray = (responseBody) => {
  if (!responseBody || typeof responseBody !== "object") return [];
  const candidates = [responseBody.weekdays, responseBody.availableWeekdays, responseBody.openedWeekdays];
  for (const candidate of candidates) {
    if (Array.isArray(candidate)) {
      return candidate.filter((d) => typeof d === "number");
    }
  }
  return [];
};

// Writes each availability slot only if no newer request already updated it.
// Overlapping weekday-mode and hour-mode calls can resolve out of order on slow
// connections; this stops a stale response from blanking the Hours-of-Day dropdown.
let lastRequestId = 0;
const lastAppliedId = { hours: 0, weekdays: 0 };

const applyAvailability = (requestId, { hours, weekdays }) => {
  const update = {};

  if (weekdays !== undefined && requestId >= lastAppliedId.weekdays) {
    lastAppliedId.weekdays = requestId;
    update.stores_available_weekdays = weekdays;
  }
  if (hours !== undefined && requestId >= lastAppliedId.hours) {
    lastAppliedId.hours = requestId;
    update.stores_available_hours = hours;
  }

  if (Object.keys(update).length > 0) {
    store.dispatch(updateStateData(update));
  }
};

// No weekdays → returns open weekdays. Weekdays given → returns open hours.
// ("calenderWeeks" typo intentional — matches backend field name.)
export const getStoresAvailableHours = async ({
  storeIds = [],
  startDate,
  endDate,
  calenderWeeks = [],
  weekdays = null,
} = {}) => {
  const requestId = ++lastRequestId; // claim order before awaiting
  const body = buildAvailabilityRequestBody({ storeIds, weekdays, startDate, endDate, calenderWeeks });

  if (body === null) {
    applyAvailability(requestId, { weekdays: [], hours: [] });
    return { success: false, message: "Missing required availability input" };
  }

  try {
    const response = await sendApiRequest("stores/available-hours", body, "POST");
    if (!response.success) {
      return { success: false, message: "API-ERROR" };
    }

    // Weekday-mode writes only weekdays: it must never clear hours, or a slow
    // weekday response could blank a freshly loaded Hours-of-Day selection.
    const isHourMode = body.weekdays?.length > 0;
    applyAvailability(
      requestId,
      isHourMode
        ? { hours: extractHoursArray(response.response) }
        : { weekdays: extractWeekdaysArray(response.response) }
    );

    return { success: true, message: response.response };
  } catch {
    return { success: false, message: "API-ERROR" };
  }
};

// per-store counts for the detailed selection popups — response not dispatched to Redux
export const getStoresDetailedAvailableHours = async ({
  storeIds = [],
  startDate,
  endDate,
  calenderWeeks = [],
  weekdays = null,
} = {}) => {
  const body = buildAvailabilityRequestBody({ storeIds, weekdays, startDate, endDate, calenderWeeks });

  if (body === null) {
    return { success: false, message: "Missing required availability input", data: null };
  }

  try {
    const response = await sendApiRequest("stores/detailed-available-hours", body, "POST");

    if (!response.success) {
      return { success: false, message: "API-ERROR", data: null };
    }

    return { success: true, data: response.response ?? null };
  } catch (err) {
    return { success: false, message: "API-ERROR", data: null };
  }
};

// fetch campaign names for filters/dropdowns etc.
// silent skips the page backdrop. Listing filters pass it; the open list has its own spinner.
export const fetchCampaignNames = async (requestOptions = {}) => {
  const campaignList = await sendApiRequest("campaigns/list", {}, "GET", {
    silent: requestOptions.silent === true,
  });
  if (typeof campaignList.success !== "undefined" && campaignList.success === true) {
    const fetchStructuredInfo = restructureCampaignNameData(campaignList.response);

    store.dispatch(
      updateStateData({
        campaign_names_info: fetchStructuredInfo,
      })
    );

    return {
      success: true,
      data: fetchStructuredInfo,
    };
  } else {
    return {
      success: false,
      data: null,
    };
  }
};

// fetch independent owner list for add campaign/clips/pictures etc. 
export const fetchIndependentOwnerList = async () => {
  const ownerList = await sendApiRequest("companies", {}, "GET", { skipRetailerViewFilter: true });
  if (typeof ownerList.success !== "undefined" && ownerList.success === true) {
    let campaignCompanyList = []
    ownerList.response.forEach((owner) => {
      // campaign company name list
      campaignCompanyList.push({ id: owner.id, label: owner.name, company_level: owner.level, visual_upload_limit: owner.loop_visual_limit, visual_upload_duration: owner.loop_visual_max_duration });
    })

    store.dispatch(
      updateStateData({
        independent_owners_list: campaignCompanyList,
      })
    );

    return {
      success: true,
    };
  } else {
    return {
      success: false,
    };
  }
};

// fetch owner names for filters/dropdowns etc.
// requestedFor is the listing path (list-campaigns, list-clips, list-loop-campaigns, list-stores).
// silent skips the page backdrop. Listing filters pass it.
export const fetchOwnerNames = async (requestedFor, requestOptions = {}) => {
  // Listing filter panes: include filter_view_company_id when a retailer is selected.
  const ownerList = await sendApiRequest("companies/" + requestedFor, {}, "GET", {
    silent: requestOptions.silent === true,
  });
  if (typeof ownerList.success !== "undefined" && ownerList.success === true) {
    let campaignCompanyList = []
    ownerList.response.forEach((owner) => {
      // campaign company name list
      campaignCompanyList.push({ id: owner.id, label: owner.name });
    })

    store.dispatch(
      updateStateData({
        companies_info: campaignCompanyList,
      })
    );

    return {
      success: true,
    };
  } else {
    return {
      success: false,
    };
  }
};

// Root retailer companies for the listing "Retailer" multi-select filter.
// Kept separate from companies_info (Owner options) so both can load together.
export const fetchRetailerRoots = async (requestOptions = {}) => {
  // Listing Retailer multi-select. Bottom-nav roots still skip this param.
  // silent skips the page backdrop. Listing filters pass it.
  const retailerRoots = await sendApiRequest("companies/retailer-roots", {}, "GET", {
    silent: requestOptions.silent === true,
  });

  if (typeof retailerRoots.success !== "undefined" && retailerRoots.success === true) {
    const retailerRootsList = (retailerRoots.response || []).map((retailer) => ({
      id: retailer.id,
      label: retailer.name,
    }));

    store.dispatch(
      updateStateData({
        retailer_roots_info: retailerRootsList,
      })
    );

    return { success: true };
  }

  return { success: false };
};

const restructureCampaignNameData = (campaignListDetails) => {
  let campaignNameArray = [];
  let campaignNameList = [];
  let activeCampaignNameList = [];
  let campaignDatesList = {};
  let campaignNameFullObj = [];
  let report_available_campaigns = [];

  campaignListDetails.forEach((campaign) => {
    campaignNameFullObj.push(campaign);
    //we will only show those campaigns for which reporting has to be done.
    const campaignProgressStatus = checkStatus(campaign.date_start, campaign.date_end);
    //create a campaign name array for filters
    if (!campaignNameArray.includes(campaign.name)) {
      campaignNameArray.push(campaign.name);
    }
    //create a campaign name array for filters
    if (!Object.values(campaignNameList).includes(campaign.name)) {
      campaignNameList.push({ id: campaign.id, label: campaign.name });
      campaignDatesList = {
        ...campaignDatesList,
        [campaign.id]: {
          campaign_start_date: campaign.date_start,
          campaign_end_date: campaign.date_end,
        },
      };
      //
      if (["Active", "Scheduled"].includes(campaignProgressStatus)) {
        activeCampaignNameList.push({ id: campaign.id, label: campaign.name });
      }
    }
    // filter campaigns for which report is available.
    if (campaign.campaign_status === 4) {
      const checkUserDetail = checkUserDetailsFromCookie();
      // Users who cannot edit across companies only see campaigns owned by their company.
      if (typeof checkUserDetail.user_detail.user_type !== "undefined" && canEditAcrossCompanies(checkUserDetail.user_detail.user_type) === false) {
        if (campaign.company_retailer.name === checkUserDetail.user_detail.assigned_company.name) {
          report_available_campaigns.push({ id: campaign.id, label: campaign.name, brand_name: campaign.brand, brand_company: campaign.company_brand.name, end_date: campaign.date_end });
        }
      } else {
        report_available_campaigns.push({ id: campaign.id, label: campaign.name, brand_name: campaign.brand, brand_company: campaign.company_brand.name, end_date: campaign.date_end });
      }
    }
  });

  return {
    campaign_name_list: campaignNameArray,
    campaign_name_obj: campaignNameList,
    campaign_dates_list: campaignDatesList,
    active_campaign_name_list: activeCampaignNameList,
    campaign_name_full_obj: campaignNameFullObj,
    report_available_campaigns: report_available_campaigns
  };
};

/**
 * Load everything the analytics dashboard needs after campaign_detail is in Redux.
 *
 * Order (intentional):
 * 1. Catalogs + report settings in parallel (adlevels, weeks, regions, stores, sections…)
 * 2. Then seed Brand/Retailer access bags + embedded_* filter state
 *
 * Preview mode skips fetchReportSettings so in-progress Report Settings edits
 * are not overwritten by the published server config.
 */
export const ANALYTICS_UNAVAILABLE_CAMPAIGN_NOT_FOUND = "campaign_not_found";
export const ANALYTICS_UNAVAILABLE_NO_STORES = "no_stores";

const isAnalyticsReportAccess = (accessFor) =>
  accessFor === "analytics" || accessFor === "brand_report";

const markAnalyticsReportUnavailable = (reason) => {
  store.dispatch(
    updateStateData({
      analytics_campaign_stores_scope_empty: true,
      analytics_report_unavailable_reason: reason,
    })
  );
  setBatchLoadingStatus(false);
};

export const loadCampaignAnalyticsDependencies = async (
  campaignId,
  viewMode,
  accessFor,
  campaignRecord
) => {
  store.dispatch(
    updateStateData({
      analytics_campaign_stores_scope_empty: false,
      analytics_report_unavailable_reason: null,
    })
  );

  const storeLoadResult = await loadAnalyticsCampaignStores(campaignId);
  const campaignStores =
    storeLoadResult.success === true && Array.isArray(storeLoadResult.stores) ? storeLoadResult.stores : [];

  if (campaignStores.length === 0) {
    store.dispatch(
      updateStateData({
        analytics_campaign_stores_scope_empty: true,
        analytics_report_unavailable_reason: ANALYTICS_UNAVAILABLE_NO_STORES,
      })
    );
    return;
  }

  // Step 1 — catalogs the filters and Embeddable variables need.
  const catalogRequests = [
    checkProductInformation(campaignId, true),
    fetchMarketingActivities(campaignId),
    fetchWeekNumbers(campaignRecord.date_start, campaignRecord.date_end),
    // Section availability map (impression per root retailer + performance flag)
    checkSectionAvailability(),
  ];

  if (accessFor !== "preview") {
    catalogRequests.push(fetchRegionsForCampaign(campaignId));
    catalogRequests.push(fetchNielsenRegionsForCampaign(campaignId));
    // Report settings supply section filter lists / order used while seeding.
    catalogRequests.push(fetchReportSettings(campaignId));
  }

  await Promise.all(catalogRequests);

  // Step 2 — Brand Report API + seed embedded_* for this viewMode.
  // Requires step 1 to have finished (stores, adlevels, weeks, regions, settings).
  await fetchBrandFilters(campaignId, viewMode);
};

//fetch single campaign
export const fetchCampaign = async (campaignid, requestFor = "all", viewMode, accessFor = "list") => {
  setBatchLoadingStatus(true)
  const campaignDetail = await sendApiRequest("campaigns/" + campaignid, {}, "GET");
  const currentStateData = store.getState().userSelections;
  if (typeof campaignDetail.success !== "undefined" && campaignDetail.success === true) {
    const record = campaignDetail.response;
    if (typeof record.error !== "undefined" && record.error === true) {
      if (isAnalyticsReportAccess(accessFor)) {
        markAnalyticsReportUnavailable(ANALYTICS_UNAVAILABLE_CAMPAIGN_NOT_FOUND);
        setBatchLoadingStatus(false);
        return { success: false };
      }
      toast("Campaign data not found", { type: "error" });
      setBatchLoadingStatus(false);
      setTimeout(() => {
        window.location.href = "/check-campaigns/list";
      }, 2000);
      return { success: false };
    } else {
      // save data in redux
      store.dispatch(
        updateStateData({
          campaign_detail: {
            campaign_id: record.id,
            campaign_name: record.name,
            campaign_start_date: record.date_start,
            campaign_end_date: record.date_end,
            brand: record.brand,
            // API still returns company_retailer; we store it as owner_company_* in Redux
            owner_company_id: record.company_retailer.id,
            owner_company_name: record.company_retailer.name,
            brand_company_id: record.company_brand.id,
            brand_company_name: record.company_brand.name,
            notes: record.notes,
            // campaign_status_code: record.campaign_status,
            // impression_report_status: record.impression_status === null ? 0 : record.impression_status,
            impression_report_status: record.impression === "available" ? 1 : 0,
            campaign_status_code: computeCampaignStatusCode(record.performance),
            campaign_active_status: checkStatus(record.date_start, record.date_end),
            retailer_id: record.company_retailer.id, //record.company_brand.id === 40 ? 40 : 2,
            campaign_stores: record?.store_names,
            // Root retailer for impression section availability lookups
            root_retailer_company: record?.root_retailer_company,
            // Kept for embeddable number_root (ReportView, etc.)
            root_company_id: record?.root_retailer_company?.id ?? record?.root_company_id,
            execution_data_for_embeddable: record?.execution_campaigns.length > 0 ? record?.execution_campaigns.map(campaign => campaign.id) : [],
          },
        })
      );

      if (requestFor === "all") {
        // Brand Report View sets brand_report_view before calling fetchCampaign.
        const userRole = currentStateData?.brand_report_view === true ? "Brand" : viewMode;

        await loadCampaignAnalyticsDependencies(
          campaignid,
          userRole,
          accessFor,
          record
        );
      } else {
        if (requestFor === "products") {
          //load adlevels for this campaign
          await checkProductInformation(campaignid, true);
        }
        if (requestFor === "marketing_activity") {
          //load adlevels for this campaign
          await checkProductInformation(campaignid, true);

          // // load campaign weeks
          await fetchWeekNumbers(record.date_start, record.date_end);

          // Campaign stores first, so activity names can be resolved from marketing_activity_stores_list.
          await loadMarketingActivityStores(campaignid);

          // // load marketing activity information
          await fetchMarketingActivities(campaignid);
        }
      }
    }

    setBatchLoadingStatus(false)

    return {
      success: true,
    };
  } else {
    if (requestFor === "all" && isAnalyticsReportAccess(accessFor)) {
      markAnalyticsReportUnavailable(ANALYTICS_UNAVAILABLE_CAMPAIGN_NOT_FOUND);
      setBatchLoadingStatus(false);
      return { success: false };
    }
    setBatchLoadingStatus(false);
    return { success: false };
  }
};

//sort campaigns by start date
const sortByStartDate = (campaignArray) => {
  return campaignArray.sort((next, prev) => {
    return formatToStandardDate(prev.campaign_start_date) - formatToStandardDate(next.campaign_start_date);
  });
};

export const compareDates = (startDate, compare = "start") => {
  const dateStrForToday = dateObjForToday(new Date());
  const today = moment.tz(dateStrForToday, platformConfig.timezone).startOf("day");
  const start = moment.tz(startDate, platformConfig.timezone).startOf("day");

  // Calculate the difference in days
  const daysDifference = today.diff(start, "days");

  let response = { daysDifference: 0 };

  if (today.isSame(start, "day")) {
    response = {
      ...response,
      status: compare === "start" ? "started_today" : "ended_today",
    };
  }

  if (today.isAfter(start, "day")) {
    response = {
      ...response,
      status: compare === "start" ? "started_days_ago" : "ended_days_ago",
      daysDifference: daysDifference,
    };
  }

  return response;
};

const computeCampaignStatusCode = (performanceReportStatus) => {
  let statusCode = 0;
  if (performanceReportStatus === "unavailable") {
    statusCode = 1;
  }

  if (performanceReportStatus === "requested") {
    statusCode = 2;
  }

  if (performanceReportStatus === "requestable") {
    statusCode = 3;
  }

  if (performanceReportStatus === "available") {
    statusCode = 4;
  }

  return statusCode;
}

// this function will check campaign status based on start/end date and add only the required information to the final array which will be returned.
const restructureCampaignData = (campaignListDetails) => {
  let restructuredActiveData = [];
  let restructuredScheduledData = [];
  let restructuredCompletedData = [];
  let restructuredAllCampaigns = [];
  let campaignNameArray = [];
  let campaignNameList = [];
  let activeCampaignNameList = [];
  let campaignCompanyList = [];
  let report_available_campaigns = [];

  let campaignDatesList = {};

  campaignListDetails.forEach((campaign) => {
    //decide campaign status by comparing current date with start and end date of campaign.
    const currentDate = standardFormatToday();
    const campaignStartDate = formatToStandardDate(campaign.date_start);
    const campaignEndDate = formatToStandardDate(campaign.date_end);
    const checkCampaignStartStatus = compareDates(campaign.date_start);
    const checkCampaignEndStatus = compareDates(campaign.date_end, "enddate");
    const campaignProgressStatus = checkStatus(campaign.date_start, campaign.date_end);
    let campaignDataObj = {
      campaign_id: campaign.id,
      campaign_name: campaign.name,
      campaign_start_date: campaign.date_start,
      campaign_end_date: campaign.date_end,
      brand: campaign.brand,
      // API still returns company_retailer; we store it as owner_company_* in Redux
      owner_company_id: campaign.company_retailer.id,
      owner_company_name: campaign.company_retailer.name,
      brand_company_id: campaign.company_brand.id,
      brand_company_name: campaign.company_brand.name,
      notes: campaign.notes,
      impression_report_status: campaign.impression === "available" ? 1 : 0,
      campaign_status_code: computeCampaignStatusCode(campaign.performance),
      campaign_start_status: checkCampaignStartStatus.status,
      campaign_end_status: checkCampaignEndStatus.status,
      days_passed: checkCampaignStartStatus.daysDifference,
      last_edit: campaign.last_edit,
      share_list: typeof campaign.share_list !== "undefined" && campaign.share_list !== null ? campaign.share_list : [],
      shared: campaign.shared,
      campaign_status: campaignProgressStatus,
      root_retailer_company: campaign.root_retailer_company,
      // Retailer column shows every retailer of the campaign (plain names, no objects)
      retailer_names: Array.isArray(campaign.retailer_names) ? campaign.retailer_names : [],
      has_marketing_activities: campaign?.has_marketing_activities === true,
    };

    //create a campaign name array for filters
    if (!campaignNameArray.includes(campaign.name)) {
      campaignNameArray.push(campaign.name);
    }
    //create a campaign name array for filters
    if (!Object.values(campaignNameList).includes(campaign.name)) {
      campaignNameList.push({ id: campaign.id, label: campaign.name });
      campaignDatesList = {
        ...campaignDatesList,
        [campaign.id]: {
          campaign_start_date: campaign.date_start,
          campaign_end_date: campaign.date_end,
        },
      };
      //
      if (["Active", "Scheduled"].includes(campaignDataObj.campaign_status)) {
        activeCampaignNameList.push({ id: campaign.id, label: campaign.name });
      }
      if (["Completed"].includes(campaignDataObj.campaign_status)) {
        const checkUserDetail = checkUserDetailsFromCookie();
        // Users who cannot edit across companies only see campaigns owned by their company.
        if (typeof checkUserDetail.user_detail.user_type !== "undefined" && canEditAcrossCompanies(checkUserDetail.user_detail.user_type) === false) {
          if (campaign.company_retailer.name === checkUserDetail.user_detail.assigned_company.name) {
            report_available_campaigns.push({ id: campaign.id, label: campaign.name });
          }
        } else {
          report_available_campaigns.push({ id: campaign.id, label: campaign.name });
        }
      }
    }
    // campaign company name list
    campaignCompanyList.push({ id: campaign.company_retailer.id, label: campaign.company_retailer.name });
    // all campaigns (irrespective of status)
    restructuredAllCampaigns.push(campaignDataObj);
  });

  return {
    all_campaigns: restructuredAllCampaigns,
    campaign_name_list: campaignNameArray,
    campaign_name_obj: campaignNameList,
    campaign_dates_list: campaignDatesList,
    active_campaign_name_list: activeCampaignNameList,
    campaign_company_list: campaignCompanyList,
    report_available_campaigns: report_available_campaigns,
  };
};

//update campaign data i.e., notes, active, status, workbook path, and tableau project id
export const updateCampaignData = async (requestBody, campaign_id) => {
  //save project id and update campaign status to be 2 i.e., data processing
  const updateData = await sendApiRequest("campaigns/data/update/" + campaign_id, requestBody, "PUT");

  if (typeof updateData.success !== "undefined" && updateData.success === true) {
    /*
      fetch campaign details once the data is updated 
      (it will automatically update the redux state with latest data)
    */
    fetchCampaign(campaign_id, "all");
    return {
      success: true,
      message: "Data updated successfully.",
    };
  } else {
    return {
      success: false,
      message: "Sorry, something went wrong.",
    };
  }
};

// to save new adlevel row
export const saveSingleAdlevelRow = async (campaign_id, adlevelObj, campaignStatusUpdate) => {
  //cross check if adlevels are added in redux store or not
  if (typeof adlevelObj !== "undefined" && adlevelObj.length !== 0) {
    const saveAdlevelResponse = await sendApiRequest("products/data/add", adlevelObj, "POST");

    if (saveAdlevelResponse.success === true) {
      // check if any error returned from the api
      if (
        typeof saveAdlevelResponse.response !== "undefined" &&
        typeof saveAdlevelResponse.response.success !== "undefined" &&
        saveAdlevelResponse.response.success === false
      ) {
        //no need to perform any action (it's unsure whether success param will be there in the actual success response, that's why temporarily we need to leave this block empty)
      } else {
        //update campaign status
        if (campaignStatusUpdate.toString() !== "3") {
          updateCampaignStatus(3, campaign_id);
        }
        fetchCampaign(campaign_id, "products");
      }
      return {
        success: true,
        api_response: saveAdlevelResponse,
      };
    }
  } else {
    return {
      success: false,
    };
  }
};

//save adlevels to the backend database
export const saveCampaignAdlevels = async (campaign_id) => {
  const currentStateData = store.getState().userSelections;
  //cross check if adlevels are added in redux store or not
  if (typeof currentStateData.adlevel_sheet_data !== "undefined" && currentStateData.adlevel_sheet_data.length !== 0) {
    const saveAdlevelResponse = await sendApiRequest("products/data/add", currentStateData.adlevel_sheet_data, "POST");

    if (saveAdlevelResponse.success === true) {
      // check if any error returned from the api
      if (
        typeof saveAdlevelResponse.response !== "undefined" &&
        typeof saveAdlevelResponse.response.success !== "undefined" &&
        saveAdlevelResponse.response.success === false
      ) {
        //no need to perform any action (it's unsure whether success param will be there in the actual success response, that's why temporarily we need to leave this block empty)
      } else {
        //update campaign status to be 1 i.e., product information saved
        // updateCampaignData({ status: 1 }, campaign_id);
        /*
          * 28 April 2025 : 
          * commented out the update campaign status api call because we are managing the status from backend now.
        */
        // updateCampaignStatus(3, campaign_id);
        //loadCampaigns();
        //fetchCampaign(campaign_id, "products");
        //reset adlevels in redux
        store.dispatch(
          updateStateData({
            adlevel_sheet_data: [],
            adlevels_saved: true,
          })
        );
      }
      return {
        success: true,
        api_response: saveAdlevelResponse,
      };
    }
  } else {
    return {
      success: false,
    };
  }
};

// to add a new adlevel manually
export const addNewProductAdlevels = async (campaign_id, adlevelRequestParam) => {
  const saveAdlevelResponse = await sendApiRequest("products/data/add", adlevelRequestParam, "POST");

  if (saveAdlevelResponse.success === true) {
    // update campaign status
    updateCampaignStatus(3, campaign_id);
    //send a request at backend to fetch latest data.
    checkProductInformation(campaign_id);
    return {
      success: true,
      api_response: saveAdlevelResponse,
    };
  } else {
    return {
      success: false,
    };
  }
};

//update adlevels (Product information)
export const updateCampaignAdlevels = async (adlevelRecords) => {
  const currentStateData = store.getState().userSelections;
  //cross check if adlevels are added in redux store or not
  if (typeof adlevelRecords !== "undefined" && adlevelRecords.length !== 0) {
    const saveAdlevelResponse = await sendApiRequest("products/data/update", adlevelRecords, "PUT");

    if (saveAdlevelResponse.success === true) {
      //reset adlevels in redux and show a link to check saved adlevels
      store.dispatch(
        updateStateData({
          adlevels_updated: true,
        })
      );
      return {
        success: true,
      };
    }
  } else {
    return {
      success: false,
    };
  }
};

//delete single adlevel based on id
export const deleteSingleAdlevel = async (adlevelId) => {
  const currentStateData = store.getState().userSelections;
  //cross check if adlevels are added in redux store or not
  if (typeof currentStateData.created_adlevels !== "undefined" && currentStateData.created_adlevels.length !== 0) {
    const deleteAdlevelResponse = await sendApiRequest("products/data/delete/" + adlevelId, "", "DELETE");

    if (deleteAdlevelResponse.success === true) {
      return {
        success: true,
        message: "adlevel deleted",
      };
    } else {
      return {
        success: false,
        message: "Sorry, something went wrong.",
      };
    }
  }
};

// delete multiple adlevels
export const deleteMultipleAdlevels = async (toBeDeletedRecords) => {
  const currentStateData = store.getState().userSelections;
  if (typeof currentStateData.created_adlevels !== "undefined" && currentStateData.created_adlevels.length !== 0) {
    //call backend api to delete multiple adlevels.
    const deleteAdlevelsResponse = await sendApiRequest("products/data/delete", toBeDeletedRecords, "DELETE");
    //return response.
    if (deleteAdlevelsResponse.success === true) {
      return {
        success: true,
        message: "adlevel deleted",
      };
    } else {
      return {
        success: false,
        message: "Sorry, something went wrong.",
      };
    }
  }
};

//fetch adlevel details based on campaign id
export const checkProductInformation = async (campaign_id, adlevel = false) => {
  const checkInfoResponse = await sendApiRequest("products/campaign/" + campaign_id, "", "GET");
  if (checkInfoResponse.success === true) {
    /*
    need to restructure the product information response to match the created_adlevel 
    format which is formed at the time when ad levels are created from upload campaign 
    sheet page.
    */
    const restructuredData = restructure_product_information(checkInfoResponse.response, campaign_id);
    if (adlevel === true) {
      fetch_adlevel_names(restructuredData.restructuredData);
    }
  }
};

//fetch stores list from backend
export const fetchStores = async (retailer_id) => {
  const checkStoresResponse = await sendApiRequest("stores", "", "GET");

  if (checkStoresResponse.success === true) {
    /*need to filter stores based on the reatailer id.*/
    filter_stores(retailer_id, checkStoresResponse.response.content);
  }
};

//to filter stores based on retailer id
const filter_stores = (retailerId, storesListResponse) => {
  let filteredData = [];
  let storeIdList = {};
  //traverse all the records from campaignData
  storesListResponse.forEach((store) => {
    if (store.retailer_id === retailerId) {
      filteredData.push({ value: store.id, label: store.name });
      storeIdList = {
        ...storeIdList,
        [store.id]: {
          name_store: store.name,
          id_region: store.region.id,
          market_type: store.id_market_type,
        },
      };
    }
  });

  //save to redux
  store.dispatch(
    updateStateData({
      stores_list: filteredData,
      stores_detail: storeIdList,
    })
  );

  return {
    filteredData,
  };
};

// Client-side matchRecords / filterCampaigns were removed — list filtering is
// handled by the loadCampaigns query params (e.g. &id_company= for owner).

// execute ETL scripts
export const executeEtl = async () => {
  const currentStateData = store.getState().userSelections;
  //subtract 2 minutes from current date and time, (Airflow requirement)
  const logical_date = new Date().setMinutes(new Date().getMinutes() - 2);
  const etlRequestBody = {
    conf: {
      arg1: currentStateData.campaign_detail.retailer_id,
      arg2: currentStateData.campaign_detail.campaign_id,
      arg3: "3",
    },
    dag_run_id: "etl_script_for_" + currentStateData.campaign_detail.campaign_id + "_" + Math.floor(Math.random() * 1000),
    logical_date: new Date(logical_date),
    note: "",
  };
  const checkEtlResponse = await sendApiRequest("etl/call", etlRequestBody, "POST");

  if (checkEtlResponse.success === true) {
    toast("ETL Request has been queued. It may take some time to complete", { type: "success" });
  } else {
    toast("Sorry, something went wrong.", { type: "error" });
  }
  return checkEtlResponse;
};

export const clearfilters = () => {
  // deleteCookie("campaign_list_filters");
  // deleteCookie("clip_list_filters");
  // deleteCookie("pic_list_filters");
  //reset campaign listing
  // store.dispatch(
  //   deleteItems([
  //     "campaign_list_filters",
  //     "filtered_campaign_list",
  //     "campaign_list_filter_applied",
  //     "clip_list_filters",
  //     "filtered_clips_list",
  //     "clips_list_filter_applied",
  //     "pic_list_filters",
  //     "filtered_pictures_list",
  //     "pics_list_filter_applied",
  //   ])
  // );
};

// save stores detail to backend db
export const addStore = async (requestBody) => {
  const checkStoreResponse = await sendApiRequest("stores/add", requestBody, "POST");
  //return response.
  if (checkStoreResponse.success === true) {
    return {
      success: true,
      message: "store added",
    };
  } else {
    return {
      success: false,
      message: "Sorry, something went wrong.",
    };
  }
};

// download campaign data
export const downloadCampaignData = async (campaignName, dataOption) => {
  const downloadUrl = await sendApiRequest(
    "api/bucket/download-excel",
    {
      campaign_name: campaignName,
      export_type: dataOption,
    },
    "POST"
  );
  if (typeof downloadUrl.success !== "undefined" && downloadUrl.success === true) {
    if (typeof downloadUrl.response.error_detail !== "undefined" && downloadUrl.response.error_detail !== "") {
      toast(downloadUrl.response.error_detail, { type: "error" });
    } else {
      // download impressions
      if (typeof downloadUrl.response.impressions !== "undefined" && downloadUrl.response.impressions !== null) {
        window.location = downloadUrl.response.impressions;
      }
      // download conversion data - total
      if (
        typeof downloadUrl.response.performance_aggregate !== "undefined" &&
        downloadUrl.response.performance_aggregate !== null
      ) {
        if (downloadUrl.response.impressions === null && downloadUrl.response.performance_store === null) {
          window.location = downloadUrl.response.performance_aggregate;
        } else {
          setTimeout(() => {
            window.location = downloadUrl.response.performance_aggregate;
          }, 1000);
        }
      }

      // download conversion data - stores
      if (
        typeof downloadUrl.response.performance_store !== "undefined" &&
        downloadUrl.response.performance_store !== null
      ) {
        if (downloadUrl.response.impressions === null && downloadUrl.response.performance_aggregate === null) {
          window.location = downloadUrl.response.performance_store;
        } else {
          setTimeout(() => {
            window.location = downloadUrl.response.performance_store;
          }, 2000);
        }
      }
    }
  } else {
    return {
      success: false,
      message: "Sorry, something went wrong",
    };
  }
};

// return campaign names that aren't older than 2 months.
export const campaign_names_in_range = () => {
  var campaign_name_obj = [{}];
  const currentStateData = store.getState().userSelections;
  const firstDayTwoMonthsAgo = formatToStandardDate(getFirstDayTwoMonthsAgo());
  firstDayTwoMonthsAgo.setDate(firstDayTwoMonthsAgo.getDate() + 1);
  const today = standardFormatToday();
  const yesterday = formatToStandardDate(today);
  yesterday.setDate(today.getDate() - 1);

  currentStateData.campaign_names_info.campaign_name_full_obj.forEach((campaign_obj) => {
    if (formatToStandardDate(campaign_obj.date_end) > firstDayTwoMonthsAgo) {
      campaign_name_obj.push({ id: campaign_obj.id, label: campaign_obj.name });
    }
  });
  return erase_duplicates(campaign_name_obj);
};

export const clip_names_in_range = (usedFor) => {
  var clip_name_obj = [{}];
  const currentStateData = store.getState().userSelections;
  const firstDayTwoMonthsAgo = formatToStandardDate(getFirstDayTwoMonthsAgo());
  firstDayTwoMonthsAgo.setDate(firstDayTwoMonthsAgo.getDate() + 1);
  const today = standardFormatToday();
  const yesterday = formatToStandardDate(today);
  yesterday.setDate(today.getDate() - 1);

  if (typeof currentStateData.clip_names_info !== "undefined") {
    currentStateData.clip_names_info.clip_full_obj.forEach((clip_obj) => {
      const clipStatus = checkStatus(clip_obj.date_start, clip_obj.date_end);

      if (typeof usedFor !== "undefined" && usedFor === "clip-overview") {
        if (formatToStandardDate(clip_obj.date_end) > firstDayTwoMonthsAgo) {
          clip_name_obj.push({ id: clip_obj.id, label: clip_obj.content });
        }
      } else {
        if (clipStatus === "Active") {
          clip_name_obj.push({ id: clip_obj.id, label: clip_obj.content });
        }
      }
    });
  }

  return erase_duplicates(clip_name_obj);
};

export const visual_names_in_range = () => {
  var visual_name_obj = [{}];
  const currentStateData = store.getState().userSelections;

  if (typeof currentStateData.visual_names_info !== "undefined") {
    currentStateData.visual_names_info.visual_names_full_obj.forEach((visual_obj) => {
      const visualStatus = checkStatus(visual_obj.date_start, visual_obj.date_end);

      if (visualStatus === "Active" && visual_obj.active === true) {
        visual_name_obj.push({ id: visual_obj.id, label: visual_obj.content });
      }
    });
  }

  return erase_duplicates(visual_name_obj);
};

export const setCampaignValuesForDynamicFilter = async (reduxKeywordToSaveValue, redux_param_name) => {
  const campaignDetails = store.getState().userSelections;
  // await fetchCampaignNames(); // wait for API
  const allCampaignNames = campaign_names_in_range(); // depends on fetched data?
  const ids = allCampaignNames.map(cmpgn => cmpgn.id);
  store.dispatch(updateStateData({
    [reduxKeywordToSaveValue]: {
      ...campaignDetails[reduxKeywordToSaveValue],
      [redux_param_name]: ids
    },
  }));

  return ids; // 🔑 return value to caller
};

export const setClipValuesForDynamicFilter = async (reduxKeywordToSaveValue, redux_param_name) => {
  const clipDetails = store.getState().userSelections;
  // await fetchClipNames(); // wait for API
  const allClipNames = clip_names_in_range(); // depends on fetched data?
  const ids = allClipNames.map(cmpgn => cmpgn.id);
  store.dispatch(updateStateData({
    [reduxKeywordToSaveValue]: {
      ...clipDetails[reduxKeywordToSaveValue],
      [redux_param_name]: ids
    },
  }));

  return ids; // 🔑 return value to caller
}

export const setLoopVisualValuesForDynamicFilter = async (reduxKeywordToSaveValue, redux_param_name) => {
  const clipDetails = store.getState().userSelections;
  // await fetchClipNames(); // wait for API
  const allClipNames = visual_names_in_range(); // depends on fetched data?
  const ids = allClipNames.map(cmpgn => cmpgn.id);
  store.dispatch(updateStateData({
    [reduxKeywordToSaveValue]: {
      ...clipDetails[reduxKeywordToSaveValue],
      [redux_param_name]: ids
    },
  }));

  return ids; // 🔑 return value to caller
}

// fetch regions for campaign
export const fetchRegionsForCampaign = async (campaignId) => {
  const regionsResponse = await sendApiRequest("regions/" + campaignId, "", "GET");
  if (regionsResponse.success === true) {
    store.dispatch(updateStateData({
      campaign_regions: regionsResponse.response.map(region => ({ value: region.name, label: region.name, nielsen_code: region.nielsenRegionCode }))
    }));
  } else {
    return [];
  }
};

// fetch Nielsen regions for campaign
export const fetchNielsenRegionsForCampaign = async (campaignId) => {
  const regionsResponse = await sendApiRequest("nielsen-regions/" + campaignId, "", "GET");
  if (regionsResponse.success === true) {
    // const testResponse = [
    //   {
    //     "id": 5,
    //     "nielsenRegionCode": "4",
    //     "nielsenRegionDesc": "Bayern",
    //     "lastEdit": "davoud",
    //     "timestampLastEdit": "2025-11-06T16:22:39.411224"
    //   }
    // ];
    store.dispatch(updateStateData({
      nielsen_campaign_regions: regionsResponse.response.map(region => ({ value: region.nielsenRegionCode, label: region.nielsenRegionCode }))
    }));
  } else {
    return [];
  }
};